import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white mt-24 border-t-2 border-black">
      <div className="nh-container py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="NextHire" className="h-12 w-12 rounded-md border-2 border-white object-cover" />
            <span className="font-display font-black text-2xl">NextHire</span>
          </div>
          <p className="mt-3 text-sm text-white/70 max-w-sm">
            Find Jobs. Build Skills. Create Your Future. — Built for youth 13–21, safe by design.
          </p>
        </div>
        <div>
          <h4 className="font-display font-black uppercase text-sm text-[var(--nh-accent)] mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/jobs" className="hover:text-[var(--nh-accent)]">Job Search</Link></li>
            <li><Link to="/resume-builder" className="hover:text-[var(--nh-accent)]">Resume Builder</Link></li>
            <li><Link to="/community" className="hover:text-[var(--nh-accent)]">Community</Link></li>
            <li><Link to="/career-coach" className="hover:text-[var(--nh-accent)]">AI Career Coach</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-black uppercase text-sm text-[var(--nh-accent)] mb-3">For You</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/signup" className="hover:text-[var(--nh-accent)]">Youth Signup</Link></li>
            <li><Link to="/signup?role=employer" className="hover:text-[var(--nh-accent)]">Employers</Link></li>
            <li><Link to="/resources" className="hover:text-[var(--nh-accent)]">Youth Resources</Link></li>
            <li><Link to="/work-permit" className="hover:text-[var(--nh-accent)]">Work Permit Help</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-black uppercase text-sm text-[var(--nh-accent)] mb-3">Trust & Safety</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/safety" className="hover:text-[var(--nh-accent)]">Youth Safety</Link></li>
            <li><Link to="/legal/scams" className="hover:text-[var(--nh-accent)]">Scam Warnings</Link></li>
            <li><Link to="/legal/community" className="hover:text-[var(--nh-accent)]">Community Guidelines</Link></li>
            <li><Link to="/legal/employers" className="hover:text-[var(--nh-accent)]">Employer Guidelines</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-[var(--nh-accent)]">Privacy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-[var(--nh-accent)]">Terms</Link></li>
            <li><Link to="/legal/contact" className="hover:text-[var(--nh-accent)]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="nh-container py-5 text-xs text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} NextHire — For Youth. By Opportunity.</span>
          <span>Made with care. Ages 13–21. Never share your personal info with strangers online.</span>
        </div>
      </div>
    </footer>
  );
}
